import mutators from '@/models'

const fields = [
  {
    name: 'Id',
    field: 'id',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 2,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Nome do Cliente',
    field: 'contact_client_name',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Contacto do Cliente',
    field: 'contact_client_phone',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Contacto do Utilizador Responsável',
    field: 'contact_user_phone',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Assunto',
    field: 'subject',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Valor Total da Proposta',
    field: 'total_price',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'number',
    rules: {
      required: true
    }
  },
  {
    name: 'Preço por Extenso',
    field: 'total_price_text',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Data da Proposta',
    field: 'date',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: true
    }
  },
  {
    name: 'Prazo de Validade',
    field: 'expiration_date',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Prazo de Entrega',
    field: 'deadline',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Prazo de Pagamento',
    field: 'payment_term',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Data da Proposta',
    field: 'date',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: true
    }
  },
  {
    name: 'Condições de Fornecimento',
    field: 'conditions',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Outros Campos',
    field: 'other_fields',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Notas',
    field: 'notes',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'actions',
    field: 'actions',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    rules: {
      required: false
    }
  }
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
